module.exports = __webpack_public_path__ + "static/media/icon_medicinska_pomagala.2c32f196.svg";